import { Component, ViewChild } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { StompService } from './services/stomp.service';
import { ChatbotService } from './pages/chatbot/chatbot.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public settings: Settings;
  chatOpen    = false;
  showTooltip = true;

  // Persist messages, history, and topic-picker state across open/close
  savedMessages: any[] = [];
  savedHistory:  {role: string, content: string}[] = [];
  savedSelectedModule: string | null = null;
  savedActiveCategory: any = null;
  savedShowModuleSelector = true;
  savedForUserKey: string | null = null;   // NEW — which user savedMessages belongs to

  @ViewChild('chatbotRef') chatbotRef: any;

  constructor(
    public appSettings: AppSettings,
    public stompService: StompService,
    public chatbotService: ChatbotService,
     private router: Router
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    // this.stompService.connect();
      const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
   if (code) {
    // Forward to our hash-based callback route, code travels as a route query param
    this.router.navigate(['/auth/microsoft/callback'], { queryParams: { code } });
  }
  }

  get isLoggedIn(): boolean {
    return this.chatbotService.isLoggedIn;
  }

  toggleChat() {
    // Before closing, save current state from the child
    if (this.chatOpen && this.chatbotRef) {
      this.savedMessages           = [...this.chatbotRef.messages];
      this.savedHistory            = [...this.chatbotRef.conversationHistory];
      this.savedSelectedModule     = this.chatbotRef.selectedModule;
      this.savedActiveCategory     = this.chatbotRef.activeCategory;
      this.savedShowModuleSelector = this.chatbotRef.showModuleSelector;
      this.savedForUserKey         = this.chatbotService.currentUserKey;   // NEW
    }
    this.chatOpen    = !this.chatOpen;
    this.showTooltip = false;

    // After opening, restore state into the child (wait one tick for *ngIf to render)
    if (this.chatOpen) {
      setTimeout(() => {
        // Only restore if the saved state belongs to the SAME logged-in
        // user — otherwise a different user (e.g. logging in after someone
        // else, without a full page reload) would inherit the previous
        // user's messages and their stale "Hi <old name>" greeting instead
        // of their own. The freshly-created ChatbotComponent has already
        // greeted the current user correctly in its own ngOnInit().
        const sameUser = this.savedForUserKey === this.chatbotService.currentUserKey;
        if (this.chatbotRef && this.savedMessages.length > 0 && sameUser) {
          this.chatbotRef.messages             = [...this.savedMessages];
          this.chatbotRef.conversationHistory  = [...this.savedHistory];
          this.chatbotRef.selectedModule       = this.savedSelectedModule;
          this.chatbotRef.activeCategory       = this.savedActiveCategory;
          this.chatbotRef.showModuleSelector   = this.savedShowModuleSelector;
        } else if (!sameUser) {
          // Different user — drop the stale cache so it can't leak into
          // a future restore either.
          this.savedMessages           = [];
          this.savedHistory            = [];
          this.savedSelectedModule     = null;
          this.savedActiveCategory     = null;
          this.savedShowModuleSelector = true;
        }
      }, 0);
    }
  }

  clearChat() {
    if (this.chatbotRef) {
      const fresh = [{
        role: 'bot',
        text: `Hi ${this.chatbotRef.userName}! 👋 I'm your ERP Assistant\nAsk me anything about your projects.`,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      }];
      this.chatbotRef.messages            = fresh;
      this.chatbotRef.conversationHistory = [];
      this.chatbotRef.selectedModule      = null;
      this.chatbotRef.activeCategory      = null;
      this.chatbotRef.showModuleSelector  = true;
      // Also clear saved state so re-open starts fresh
      this.savedMessages           = fresh;
      this.savedHistory            = [];
      this.savedSelectedModule     = null;
      this.savedActiveCategory     = null;
      this.savedShowModuleSelector = true;
    }
  }
}